import client from './client';
import { ApolloProvider as Provider } from '@apollo/client/react';

const ApolloProvider = ({ children }) => (
  <Provider client={client}>{children}</Provider>
);

export default ApolloProvider;
